import { configuraçõesApi } from '@/configurações/configuraçõesApi'
import { autorizaçãoHeader } from '@/utilitários/autorizaçãoHeader'
import axios from 'axios'

export const api = () => {
  let isRedirecting = false
  const instance = axios.create({
    baseURL: `${configuraçõesApi.ip}${configuraçõesApi.path}`,
    timeout: configuraçõesApi.timeout,
    headers: {
      ...configuraçõesApi.headers,
      ...autorizaçãoHeader(),
    },
  })

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response?.status === 401) {
        if (localStorage.getItem('@Esforce:Auth-Token')) {
          if (!isRedirecting && window.location.pathname !== '/login') {
            isRedirecting = true
            localStorage.removeItem('@Esforce:Auth-Token')
            window.location.href = '/login'
          }
        }
      }

      return Promise.reject(error)
    },
  )

  return instance
}

export const apiUpload = () =>
  axios.create({
    baseURL: `${configuraçõesApi.ip}${configuraçõesApi.path}`,
    timeout: configuraçõesApi.timeout,
    headers: {
      ...autorizaçãoHeader(),
      'Content-Type': 'multipart/form-data',
    },
  })
